import api from './axios';

export const getDocuments = (dossierId) =>
    api.get(`/documents/?dossier=${dossierId}`);

export const uploadDocument = (formData) =>
    api.post('/documents/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

export const deleteDocument = (id) =>
    api.delete(`/documents/${id}/`);